import * as THREE from "three";

// 포인트 마커 생성 함수
export const createPointMarker = (
  position,
  color = 0xff00ff,
  size = 0.5,
  markerId,
  equipmentId,
  pathGenerateMode
) => {
  //  지오메트리 생성
  const geometry = new THREE.BoxGeometry(0.5, 0.5, 0.5);

  // 재질 생성 (빛나는 효과)
  const material = new THREE.MeshBasicMaterial({
    color: color,
    transparent: true,
    opacity: 0.8,
  });

  // 메시 생성
  const sphere = new THREE.Mesh(geometry, material);

  sphere.userData = {
    markerId: markerId || null,
    type: pathGenerateMode ? "point-marker" : "obstacle-marker",
    equipmentId: equipmentId || null,
    timestamp: Date.now(),
  };

  // 위치 설정
  sphere.position.set(position.x, position.y, position.z);

  // 사용자 정의 속성 추가
  // sphere.userData = {
  //   type: "point-marker",
  //   timestamp: Date.now(),
  // };

  return sphere;
};

// 시작점 마커 생성
export const createStartMarker = (position) => {
  return createPointMarker(position, 0x00ff00, 0.8); // 녹색, 크게
};

// 도착점 마커 생성
export const createEndMarker = (position) => {
  return createPointMarker(position, 0xff0000, 0.8); // 빨간색, 크게
};

// 중간점 마커 생성
export const createWaypointMarker = (position) => {
  return createPointMarker(position, 0xffff00, 0.5); // 노란색, 작게
};

// 장애물 마커 생성
export const createObstacleMarker = (position) => {
  return createPointMarker(position, 0xff6600, 0.6); // 주황색, 중간 크기
};

// 마커 제거 함수
export const removeMarker = (scene, marker) => {
  if (marker && scene) {
    scene.remove(marker);
    marker.geometry.dispose();
    marker.material.dispose();
  }
};

// 모든 마커 제거 함수
export const removeAllMarkers = (scene) => {
  if (!scene) return;

  const markersToRemove = [];

  // 재귀적으로 모든 자식 객체를 탐색하는 함수
  const findMarkers = (object) => {
    // 현재 객체가 마커인지 확인
    if (object.userData && object.userData.type === "point-marker") {
      markersToRemove.push(object);
    }

    // 자식 객체들도 확인
    if (object.children && object.children.length > 0) {
      for (let i = 0; i < object.children.length; i++) {
        findMarkers(object.children[i]);
      }
    }
  };

  // scene부터 시작해서 모든 객체 탐색
  findMarkers(scene);

  // 찾은 마커들 제거
  markersToRemove.forEach((marker) => {
    removeMarker(scene, marker);
  });
};
